import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { deleteAdmin, updateStatus } from "./api"
import useAdminCommand from "./useAdminCommand"
import { adminName } from "./adminDisplay"

export default function AdminOperationDialog({ account, action = "deleted", onClose, onSuccess }) {
  const command = useAdminCommand()
  const pending = command.status === "pending"
  const unknown = command.status === "unknown"
  const verb = ({ deleted: "Delete", blocked: "Block", activated: "Activate" })[action]
  const submit = () => command.start((id, socketClientId) => action === "deleted"
    ? deleteAdmin(account.id, { socketClientId }, id)
    : updateStatus(account.id, action, { socketClientId }, id), onSuccess)
  return <Modal isOpen toggle={pending ? undefined : onClose} keyboard={!pending} backdrop={pending ? "static" : true}>
    <ModalHeader toggle={pending ? undefined : onClose}>{verb} admin account?</ModalHeader>
    <ModalBody>
      <p><strong>{adminName(account)}</strong> · #{account.userId}</p>
      <p>{action === "deleted" ? "This marks the account as deleted and revokes its access. Its record remains in the history."
        : action === "blocked" ? "This blocks the account and revokes its current access."
          : account.status === "pending"
            ? "This marks the account as activated. Pending accounts can already sign in; an activated super admin can also manage administrative accounts."
            : "This allows the account to sign in again."}</p>
      {pending && <p role="status">Waiting for confirmation…</p>}
      {unknown && <p role="status">The request was sent, but its result is not confirmed yet. Check its status before trying another operation.</p>}
      {command.status === "error" && <p role="alert" className="text-danger">{command.message}</p>}
    </ModalBody>
    <ModalFooter>
      <button type="button" className="btn btn-light" disabled={pending} onClick={onClose}>{unknown ? "Close" : "Cancel"}</button>
      {unknown ? <button type="button" className="btn btn-primary" onClick={command.check}>Check status</button>
        : <button type="button" className={"btn btn-" + (action === "deleted" ? "danger" : "primary")} disabled={pending}
          onClick={submit}>{pending ? "Processing…" : verb + " account"}</button>}
    </ModalFooter>
  </Modal>
}
